import React, { FC, useEffect, useState } from 'react';
import s from './PromptTextEditToolbar.module.css';
import { useSelector } from 'react-redux';
import { selectActivePrompt } from '../../../../store/selectors/pageSelectors';
import PropertiesBlock from '../prompt-blocks/PropertiesBlock';
import TemplatesBlock from '../prompt-blocks/TemplatesBlock';
import ToneBlock from '../prompt-blocks/ToneBlock';
import VoiceBlock from '../prompt-blocks/VoiceBlock';
import EditBlock from '../prompt-blocks/EditBlock';
import HashtagsBlock from '../prompt-blocks/HashtagsBlock';
import UploadBlock from '../prompt-blocks/UploadBlock';
import SuggestionsBlock from '../prompt-blocks/SuggestionsBlock';
import ReferencesBlock from '../prompt-blocks/ReferencesBlock';
import ImproveTextBlock from '../prompt-blocks/ImproveTextBlock';
import ReactQuill from 'react-quill';

type PromptTextEditToolbarProps = {
    quillRef: React.RefObject<ReactQuill>;
};

const PromptTextEditToolbar: FC<PromptTextEditToolbarProps> = ({ quillRef }) => {
    const activePrompt = useSelector(selectActivePrompt);
    const [activeTab, setActiveTab] = useState<'properties' | 'templates' | 'prompt'>('properties');
    const tabMap: Record<string, JSX.Element> = {
        tone: <ToneBlock />,
        voice: <VoiceBlock />,
        edit: <EditBlock />,
        improve: <ImproveTextBlock quillRef={quillRef} />,
        suggestions: <SuggestionsBlock />,
        hashtags: <HashtagsBlock />,
        upload: <UploadBlock />,
        references: <ReferencesBlock />,
    };

    useEffect(() => {
        if (activePrompt) {
            setActiveTab('prompt');
        }
        if (activePrompt === null) {
            setActiveTab('properties');
        }
    }, [activePrompt]);

    const renderTabContent = () => {
        if (activeTab === 'properties') return <PropertiesBlock />;
        if (activeTab === 'templates') return <TemplatesBlock />;
        if (activeTab === 'prompt' && activePrompt && tabMap[activePrompt])
            return tabMap[activePrompt];
        return null;
    };

    return (
        <div className={s.container}>
            <div className={s.tab_buttons}>
                <button
                    className={`${s.tab_button} ${activeTab === 'properties' ? s.active : ''}`}
                    onClick={() => setActiveTab('properties')}
                >
                    Properties
                </button>
                <button
                    className={`${s.tab_button} ${activeTab === 'templates' ? s.active : ''}`}
                    onClick={() => setActiveTab('templates')}
                >
                    Templates
                </button>
                {activePrompt && (
                    <button
                        className={`${s.tab_button} ${activeTab === 'prompt' ? s.active : ''}`}
                        onClick={() => setActiveTab('prompt')}
                    >
                        {(activePrompt as string).charAt(0).toUpperCase() +
                            (activePrompt as string).slice(1)}
                    </button>
                )}
            </div>

            {renderTabContent()}
        </div>
    );
};

export default PromptTextEditToolbar;
